'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import { BulletCheckIcon } from '@repo/ui/BulletCheckIcon'

export const BulletPoint = ({ text }) => {
  return (
    <MUIStack data-testid="BulletPoint" direction="row" alignItems="center" gap={2}>
      <BulletCheckIcon sx={{ width: '16px', height: '16px', fontSize: '16px' }} />
      <MUITypography variant="body1" sx={{ mb: 0, color: 'text.primary' }}>
        {text}
      </MUITypography>
    </MUIStack>
  )
}

BulletPoint.propTypes = {
  text: PropTypes.string
}
